import { Table } from "antd";
import { useEffect, useRef, useMemo } from "react";
import { getColumnSearchProps } from "../../../utils/tables";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/user";


const formatTime = (value) => {
  if (!value && value !== 0) return "-";
  const str = String(value).trim().toLowerCase();
  if (!str || str === "0" || str === "0min" || str === "0.00min") return "0seg";


  const match = str.match(/^([\d.]+)\s*min$/);
  if (!match) return str;

  const totalMinutes = parseFloat(match[1]);
  if (isNaN(totalMinutes)) return str;

  const minutes = Math.floor(totalMinutes);
  const seconds = Math.round((totalMinutes - minutes) * 60);

  if (minutes === 0 && seconds > 0) return `${seconds}seg`;
  if (seconds === 0) return `${minutes}min`;
  return `${minutes}min ${seconds}seg`;
};

const OrderDeliveryTimeInShift = ({
  todayOrders,
  getTodayOrders,
  loadingTable,
  filtersRef,
  currentPage = 1,
  pageSize = 10,
  tableFilters = {},
  onTableChange,
  onSearchApply,
}) => {
  const user = useSelector(selectUser);
  const isAdmin = user.admin;
  const isFirstRender = useRef(true);
  const searchInput = useRef(null);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getTodayOrdersHandler();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, tableFilters]);

  useEffect(() => {
    const countup = setInterval(() => {
      getTodayOrdersHandler();
    }, 30000);
    return () => clearInterval(countup);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, tableFilters]);

  const getTodayOrdersHandler = () => {
    getTodayOrders({
      user: user.id,
      isAdmin,
      current: currentPage,
      pageSize: pageSize,
      filters: tableFilters,
    });
  };

  const columns = useMemo(
    () => [
      {
        title: "Ticket",
        dataIndex: "ticket",
        key: "ticket",
        filteredValue: tableFilters?.ticket ? [tableFilters.ticket] : null,
        ...getColumnSearchProps(
          "ticket",
          searchInput,
          filtersRef,
          false,
          onSearchApply
        ),
      },
      {
        title: "Tipo de orden",
        dataIndex: "tipo_orden",
        key: "tipo_orden",
        filters: [
          { value: "takeout", text: "PARA LLEVAR" },
          { value: "delivery", text: "DOMICILIO" },
        ],
        filteredValue: tableFilters?.tipo_orden
          ? [tableFilters.tipo_orden]
          : null,
        filterMultiple: false,
        render: (value) => value,
      },
      {
        title: "Tiempo preparación",
        dataIndex: "tiempos",
        key: "tiempos_preparacion",
        align: "center",
        render: (tiempos) => formatTime(tiempos?.preparacion),
      },
      {
        title: "Tiempo recolección",
        dataIndex: "tiempos",
        key: "tiempos_recoleccion",
        align: "center",
        render: (tiempos) => formatTime(tiempos?.recoleccion),
      },
      {
        title: "Tiempo espera",
        dataIndex: "tiempos",
        key: "tiempos_espera",
        align: "center",
        render: (tiempos) => formatTime(tiempos?.espera),
      },
      {
        title: "Tiempo despacho",
        dataIndex: "tiempos",
        key: "tiempos_despacho",
        align: "center",
        render: (tiempos) => formatTime(tiempos?.despacho),
      },
      {
        title: "Tiempo en camino",
        dataIndex: "tiempos",
        key: "tiempos_camino",
        align: "center",
        render: (tiempos) => formatTime(tiempos?.camino),
      },
      {
        title: "Tiempo total",
        dataIndex: "tiempos",
        key: "tiempos_total",
        align: "center",
        render: (tiempos) => formatTime(tiempos?.total),
      },
    ],
    [tableFilters, filtersRef, onSearchApply]
  );

  return (
    <Table
      loading={loadingTable}
      columns={columns}
      dataSource={todayOrders?.orders || []}
      rowKey={(record, i) => record?.id ?? record?.ticket ?? i}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: todayOrders?.total,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      }}
      onChange={onTableChange}
    />
  );
};

export default OrderDeliveryTimeInShift;
